import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BrandMark from "@/components/base/BrandMark";

/**
 * En-tête dédié à la page « Suivre ma demande » : plus compact que la landing,
 * translucide puis opaque au défilement, avec une fine barre de progression.
 */
export default function TrackHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const top = window.scrollY;
      setScrolled(top > 16);
      const height = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(height > 0 ? Math.min(100, (top / height) * 100) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <BrandMark />
          <span className="leading-tight">
            <span
              className={`block text-sm font-semibold font-heading ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              WaitechEdu
            </span>
            <span
              className={`block text-xs ${
                scrolled ? "text-foreground-500" : "text-background-50/75"
              }`}
            >
              Suivi de demande de compte
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <Link
            to="/"
            className={`hidden items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer sm:inline-flex ${
              scrolled
                ? "text-foreground-700 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className="ri-arrow-left-line"></i>
            Accueil
          </Link>
          <Link
            to="/login"
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? "bg-primary-600 text-white hover:bg-primary-700"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-login-box-line"></i>
            Se connecter
          </Link>
        </div>
      </div>

      <div className="h-0.5 w-full bg-transparent">
        <div
          className="h-full bg-accent-500 transition-[width] duration-150 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </header>
  );
}